import { render, staticRenderFns } from "./about.vue?vue&type=template&id=af920a36&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&id=af920a36&scoped=true&lang=scss&"
import style1 from "./about.vue?vue&type=style&index=1&id=af920a36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af920a36",
  null
  
)

export default component.exports